/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ListPraetorPolicyPlansParams = zod.object({
	version: zod.string().optional()
});

export type ListPraetorPolicyPlansParams = zod.input<typeof ListPraetorPolicyPlansParams>;
export type ListPraetorPolicyPlansParamsOutput = zod.output<typeof ListPraetorPolicyPlansParams>;
